const ISO_DATETIME_WITHOUT_TZ =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,6})?)?$/;

const normalizeApiDateString = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return trimmed;
  }
  if (ISO_DATETIME_WITHOUT_TZ.test(trimmed)) {
    return `${trimmed}Z`;
  }
  return trimmed;
};

export const parseApiDateTime = (value?: string | null): Date | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const parsed = new Date(normalizeApiDateString(value));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getApiDateTimeTimestamp = (value?: string | null): number | null => {
  const parsed = parseApiDateTime(value);
  return parsed ? parsed.getTime() : null;
};
